var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggle-container"
  }, [(_vm.longest) ? _c('span', {
    ref: "longest",
    domProps: {
      "innerHTML": _vm._s(_vm.longest)
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "id": _vm.id
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": function($event) {
        _vm.$emit('input', $event.target.checked)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.id
    }
  }, [_c('div', {
    staticClass: "toggle-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "toggle-text"
  }, [_vm._v(_vm._s(_vm.value ? _vm.labels[0] : _vm.labels[1]))])])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0dfe430b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dfe430b","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/components/form/toggle.vue
// module id = 297
// module chunks = 3